/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { SiteProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const siteProcessFetchSiteProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const siteProcessFetchSiteProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SiteProcessTypes.SITE_PROCESS_FETCH_SITE_PROCESS_LOADING]: siteProcessFetchSiteProcessLoading,
  [SiteProcessTypes.SITE_PROCESS_FETCH_SITE_PROCESS_SUCCESS]: siteProcessFetchSiteProcessSuccess
});
